<!--
 * @Autor: yingna.gao
 * @Date: 2022-11-03 13:26:14
 * @LastEditTime: 2022-12-28 12:53:13
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/report-config/report-config-edit.vue
-->
<template>
  <div  class="report-config-warp">
    <h2 class="edm-form-title">
      <span class="edm-form-title--text">编辑报表</span>
      <div>
        <el-button size="small" type="success" @click.stop="save()">保存</el-button>
        <back style="padding-left:8px;" @back="closeModel"></back>
      </div>
    </h2>
    <div>
      <el-form ref="formEl" :model="formData"  :rules="formRules" class="demo-formData clearfix" label-position="top">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="报表编码" prop="reportCode">
              <el-input
                v-model="formData.reportCode"
                :disabled="!!formData.id"
                :placeholder="$t('public.pleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报表名称" prop="reportName">
              <el-input
                v-model="formData.reportName"
                :placeholder="$t('public.pleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据源" prop="datasourceId">
              <el-select
                v-model="formData.datasourceId"
                class="w100"
                :placeholder="$t('public.pleaseSelect')"
              >
                <el-option
                  v-for="option in dataSourceList"
                  :key="option.id"
                  :label="option.datasourceName"
                  :value="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- SQL表达式 -->
          <el-col :span="20" style="position: relative">
            <el-form-item label="SQL表达式" prop="originalSql">
              <el-input
                v-model="formData.originalSql"
                type="textarea"
                :rows="4"
                :placeholder="`${$t('public.pleaseEnter')}SQL，${$t('common.wordCountLimit', [
                  $getInputMaxLimitConst('limit4000')
                ])}`"
                :maxlength="$getInputMaxLimitConst('limit4000')"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-button
              size="small"
              type="success"
              style="position: absolute; bottom: 22px; right: -60px"
              @click.stop="testSQL()"
            >
              测试
            </el-button>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 描述 -->
          <el-col :span="20">
            <el-form-item label="描述">
              <el-input
                v-model="formData.description"
                type="textarea"
                :rows="4"
                :placeholder="`${$t('public.pleaseEnter')}描述，${$t('common.wordCountLimit', [
                  $getInputMaxLimitConst('limit200')
                ])}`"
                :maxlength="$getInputMaxLimitConst('limit200')"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="tab-info">
      <el-tabs v-model="activeName" class="custom-tabs">
        <el-tab-pane label="搜索列" name="search">
          <search-config-list ref="searchConfigListEl"/>
        </el-tab-pane>
        <el-tab-pane label="表格列" name="table">
          <report-table-list ref="reportTableListEl"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Back from "@/components/common/Back";
import SearchConfigList from "./inner-components/search-config-list.vue";
import ReportTableList from "./inner-components/report-table-list.vue";
import excelApi from "@/api/excel/excel";
import { validateSpace } from "@/utils/validate";
import reportConfigApi from "@/api/report-config/index";
export default {
  name: "ReportConfigEdit",
  components: {
    Back,
    SearchConfigList,
    ReportTableList
  },
  provide() {
    return {
      sqldata: () => ({
        originalSql: this.formData.originalSql,
        datasourceId: this.formData.datasourceId
      })
    };
  },
  data() {
    return {
      activeName: "search",
      formData: {
        reportCode: "",
        reportName: "",
        originalSql: "",
        description: "",
        datasourceId: ""
      },
      dataSourceList: [],
      formRules: {
        reportCode: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}报表编码`,
            trigger: "blur"
          },
          { validator: validateSpace, trigger: ["blur"] }
        ],
        reportName: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}}报表名称`,
            trigger: "blur"
          },
          { validator: validateSpace, trigger: ["blur"] }
        ],
        originalSql: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}}SQL表达式`,
            trigger: "blur"
          },
          { validator: validateSpace, trigger: ["blur"] }
        ],
        datasourceId: [
          {
            required: true,
            message: `${this.$t("public.pleaseChoose")}数据源`,
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    this.getDatasourceList();
    this.getReportDetails();
  },
  activated() {
    this.getDatasourceList();
    this.getReportDetails();
  },
  methods: {
    // 获取数据源
    getDatasourceList() {
      excelApi.getDatasource().then(res => {
        this.dataSourceList = res.data;
      });
    },
    getReportDetails() {
      const params = {
        id: this.$route.query.id
      };
      reportConfigApi.getReportDetails(params).then(res => {
        if (res.success && res.data) {
          this.formData = res.data;
          this.$refs.searchConfigListEl.setData(res.data);
          this.$refs.reportTableListEl.setData(res.data);
        }
      });
    },
    testSQL() {
      reportConfigApi.testSql({ originalSql: this.formData.originalSql, datasourceId: this.formData.datasourceId }).then(res => {
        if (res.success) {
          this.$message.success("sql表达式正确");
        }
      });
    },
    save() {
      this.$refs.formEl.validate(valid => {
        if (valid) {
          if (!this.$refs.searchConfigListEl.validateForm()) {
            this.activeName = "search";
            return;
          }
          if (!this.$refs.reportTableListEl.validateForm()) {
            this.activeName = "table";
            return;
          }
          const params = this.formData;
          const filterList = this.$refs.searchConfigListEl.formData.tableData.map(searchItem => ({
            columnName: searchItem.columnName,
            searchLabel: searchItem.searchLabel,
            columnFilterJson: JSON.stringify(searchItem.columnFilterJson),
            description: searchItem.description
          }));
          params["reportFilterParamDTOList"] = filterList || [];
          params["reportColumnConfigDTOList"] = this.$refs.reportTableListEl.formData.tableData;
          reportConfigApi.updateDynamicReport(params).then(res => {
            if (res.success) {
              this.$message.success("编辑报表成功");
              this.closeModel();
            }
          });
        }
      });
    },
    closeModel() {
      this.$router.push({
        path: "/report-config/report-config-list"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.report-config-warp{
    padding: 24px;
    height: 100%;
    overflow-y: auto;
}
.edm-form-title {
  display: flex;
  padding-bottom: 16px;
  font-size: 18px;
  line-height: 18px;
  justify-content: space-between;

  .edm-form-title--text {
    font-weight: 500;

    &::before {
      display: inline-block;
      width: 3px;
      height: 18px;
      margin-right: 8px;
      vertical-align: middle;
      background: #00b259;
      content: '';
      opacity: 1;
    }
  }
}
</style>
